import { ChevronDown } from 'lucide-react';

/**
 * @param {{
 *   title?: string | null,
 *   showSeparator?: boolean,
 *   collapsible?: boolean,
 *   isOpen?: boolean,
 *   onToggle?: () => void,
 *   children: import('react').ReactNode,
 * }} props
 */
const SidebarSection = ({
  title,
  showSeparator = false,
  collapsible = false,
  isOpen = true,
  onToggle,
  children,
}) => (
  <div className={showSeparator ? 'sidebar-section-separator mt-5 border-t pt-5' : ''}>
    {title && collapsible && (
      <button
        type="button"
        className="sidebar-section-header group mb-2 flex w-full items-center gap-2 rounded-md py-1.5 pl-1 pr-0 text-left"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="sidebar-section-title min-w-0 flex-1 text-xs font-semibold uppercase tracking-wide">
          {title}
        </span>
        <ChevronDown
          className={`sidebar-section-chevron h-3 w-3 shrink-0 transition-[transform,opacity] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] ${
            isOpen ? 'rotate-0' : '-rotate-90'
          }`}
          aria-hidden
        />
      </button>
    )}
    {title && !collapsible && (
      <p className="sidebar-section-title mb-3 ml-1 text-xs font-semibold uppercase tracking-wide">
        {title}
      </p>
    )}
    <div
      className={`sidebar-section-panel ${collapsible && !isOpen ? 'sidebar-section-panel--collapsed' : ''}`}
    >
      <div className="sidebar-section-panel-inner">
        <div className="flex flex-col gap-y-2.5">{children}</div>
      </div>
    </div>
  </div>
);

export default SidebarSection;
